module.exports = __webpack_public_path__ + "img/halfling_13.86895748.png";